import { Component } from '@angular/core';
import { AuthorizationService } from '../../core';
@Component({
  standalone: false,
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss']
})
export class AuthorizeComponent {
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  listCodeAuthorization: any[];
  constructor(
    public authorizationService: AuthorizationService
  ) { }

  generate() {
    this.authorizationService.generateCode().subscribe(item => {
      const value: any[] = item.data;
      this.listCodeAuthorization = value.map(cod => {
        return { value: cod, state: true };
      });
    });
  }
  remove(item: string): void {
    this.submit(item);
  }

  submit(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    this.listCodeAuthorization.map(cod => {
      if (cod.value === item) {
        cod.state = false;
      }
      return cod;
    });
  }
}
